import { render } from "./ViewListAnakCatatanDiskusi.vue?vue&type=template&id=63efaf75"
import script from "./ViewListAnakCatatanDiskusi.vue?vue&type=script&lang=js"
export * from "./ViewListAnakCatatanDiskusi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__